// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1cHv_","header":"PatientQuestionnaire_header__rdvAH","info":"PatientQuestionnaire_info__a8jrC"};